import { __assign } from "tslib";
import { connectMediaStore, useMMSelector, useMMDispatchActions, } from './withOwnReduxStore';
import { changeCurrentMediaSource, } from '../actions';
import { getCurrentMediaSource, getMediaSourceTypes, getWithMediaSourceSelector, } from '../selectors';
export var useCurrentMediaSource = function () { return (__assign(__assign({}, useMMSelector(function (state) { return ({
    currentMediaSource: getCurrentMediaSource(state),
    mediaSourceTypes: getMediaSourceTypes(state),
    withMediaSourceSelector: getWithMediaSourceSelector(state),
}); })), useMMDispatchActions({
    changeCurrentMediaSource: changeCurrentMediaSource,
}))); };
export default (function (component) {
    return connectMediaStore(function (state, ownProps) { return ({
        currentMediaSource: getCurrentMediaSource(state) || ownProps.initialMediaSource,
        mediaSourceTypes: getMediaSourceTypes(state) || ownProps.mediaSourceTypes,
        withMediaSourceSelector: getWithMediaSourceSelector(state) !== undefined
            ? getWithMediaSourceSelector(state)
            : ownProps.withMediaSourceSelector,
    }); }, { changeCurrentMediaSource: changeCurrentMediaSource })(component);
}); // redux is a bit dumb with generics
//# sourceMappingURL=withCurrentMediaSource.js.map